import { Bell } from "lucide-react"
import { Button } from "@/components/ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

export function NotificationBell() {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" disabled aria-label="Powiadomienia">
          <Bell />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Powiadomienia (wkrótce)</TooltipContent>
    </Tooltip>
  )
}
